/**
 * @Description: 全局页面loading控制
 */

const statusList = 'loading offline nothing'.split(' ')

/**
 *
 * @param className
 * @param cls
 */
function removeClass(className, cls) {
    return className.replace(new RegExp(`(\\s|^)${cls}(\\s|$)`), ' ').trim()
}

function hasClass(className, cls) {
    return new RegExp(`(\\s|^)${cls}(\\s|$)`).test(className)
}

/**
 * 是否含有样式
 */
const hadClass2 = (ele, cln) => (` ${document.querySelector(ele).className} `).indexOf(` ${cln} `) > -1

/**
 * 移除样式
 */
export const removeClass2 = (ele, cln) => {
    document.querySelector(ele).classList.remove(cln)
}

/**
 * 添加样式
 */
export const addClass2 = (ele, cln) => {
    document.querySelector(ele).classList.add(cln)
}

/**
 * 切换样式
 */
export const toggleClass = (ele, cln) => {
    if (hadClass2(ele, cln)) {
        removeClass2(ele, cln)
    } else {
        addClass2(ele, cln)
    }
}

/**
 *
 * @param className
 * @param cls
 * @returns {*}
 */
function addClass(className, cls) {
    if (hasClass(className, cls)) {
        return className
    }
    return `${className.trim()} ${cls}`
}
export function switchTo(status) {
    let { className } = window.document.body
    statusList.forEach((s) => {
        if (s === status) {
            className = addClass(className, status)
        } else {
            className = removeClass(className, status)
        }
    })
    window.document.body.className = className
}

export function off(status) {
    window.document.body.className = removeClass(window.document.body.className, status)
}


